__turbopack_context__.v({
  "card": "GiftsSection-module-scss-module__N0WjzG__card",
  "cardHeader": "GiftsSection-module-scss-module__N0WjzG__cardHeader",
  "cardImage": "GiftsSection-module-scss-module__N0WjzG__cardImage",
  "cardTitle": "GiftsSection-module-scss-module__N0WjzG__cardTitle",
  "cards": "GiftsSection-module-scss-module__N0WjzG__cards",
  "plus": "GiftsSection-module-scss-module__N0WjzG__plus",
  "plusIcon": "GiftsSection-module-scss-module__N0WjzG__plusIcon",
  "root": "GiftsSection-module-scss-module__N0WjzG__root",
  "title": "GiftsSection-module-scss-module__N0WjzG__title",
  "tooltipButton": "GiftsSection-module-scss-module__N0WjzG__tooltipButton",
  "tooltipIcon": "GiftsSection-module-scss-module__N0WjzG__tooltipIcon",
});
